import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setAdminAuth } from "../store/menupro.admin.store";
import { testAdminAuth } from "../api/menupro.api";
import "./admin.css";

export default function AdminLogin() {
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async () => {
    setErr("");

    if (!u || !p) {
      setErr("Username və password yazın");
      return;
    }

    try {
      setLoading(true);

      // ✅ backend-də real yoxlama
      await testAdminAuth(u, p);

      // uğurludursa yadda saxla
      setAdminAuth(u, p);

      navigate("/menupro/admin");
    } catch (e) {
      setErr("Username və ya password səhvdir");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-card">
        <div className="admin-title">MenuPro Admin Login</div>

        {err && <div className="admin-error">{err}</div>}

        <input
          className="admin-input"
          placeholder="Username"
          value={u}
          onChange={(e) => setU(e.target.value)}
        />

        <input
          className="admin-input"
          type="password"
          placeholder="Password"
          value={p}
          onChange={(e) => setP(e.target.value)}
        />

        <button
          className="admin-btn primary"
          onClick={submit}
          disabled={loading}
        >
          {loading ? "Yoxlanılır..." : "Daxil ol"}
        </button>
      </div>
    </div>
  );
}
